import React from 'react';
import { StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { images } from '../data/landing';
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-white" data-id="element-78" data-mp="ehtm248snfri">
      <div className="mx-auto grid max-w-content grid-cols-1 items-center gap-14 px-6 pb-16 pt-14 lg:grid-cols-[1.05fr_1fr] lg:gap-16 lg:pb-24 lg:pt-20" data-id="element-79" data-mp="9llaf0tt24p3">
        <div data-id="element-80" data-mp="1297cu5rar3ad">
          <p className="mb-6 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-nature-dark" data-id="element-81" data-mp="12a0it4iflorg">
            <span className="h-1.5 w-1.5 rounded-full bg-nature" aria-hidden="true" data-id="element-82" data-mp="xaxfppm0hsm4" />
            Megapack para entrenadores de running
          </p>

          <h1 className="font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl" data-id="element-83" data-mp="ncglmjrs0xvu">
            Si sos profe de running, este pack es para vos.{' '}
            <span className="text-sunset" data-id="element-84" data-mp="382fgpsnq3ch1">
              Cambiá tu forma de dar las clases.
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-soft" data-id="element-85" data-mp="3j89618jhw3nf">
            El sistema integral para organizar tus clases, mejorar la técnica de
            tus alumnos y profesionalizar tu servicio desde el primer día.
          </p>

          <div className="mt-9" data-id="element-86" data-mp="39cfm343g57vm">
            <CtaButton size="lg" location="hero" data-id="element-87" data-mp="3e961dp7ffzfz">
              Quiero profesionalizar mis clases
            </CtaButton>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-4 gap-y-2" data-id="element-88" data-mp="30h9dxygpedpx">
            <div className="flex items-center gap-1" aria-hidden="true" data-id="element-89" data-mp="358zpg7rdn7ix">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-sunset text-sunset" data-id="element-90" data-mp="2qlelycqlb6ah" data-mpi={i} />)}
            </div>
            <p className="text-sm font-medium text-ink-soft" data-id="element-91" data-mp="2hix2g62bkrr6">
              <span className="font-bold text-ink" data-id="element-92" data-mp="2hljas7x1bbag">Más de 300 entrenadores</span>{' '}
              ya transformaron su método de trabajo.
            </p>
          </div>
        </div>

        <div className="relative" data-id="element-93" data-mp="s44ghj521dfs">
          <div className="overflow-hidden rounded-[2rem] bg-cream" data-id="element-94" data-mp="nat7pcgomml8">
            <img src={images.hero} alt="Entrenador de running sonriente al amanecer en un parque, con su grupo estirando al fondo" className="h-full w-full object-cover" width={928} height={1160} data-id="element-95" data-mp="n9i4bdr5fgun" />
          </div>

          <div className="absolute -bottom-8 -left-6 w-40 rounded-2xl border border-cream-deep bg-white p-3 shadow-2xl shadow-ink/10 sm:w-52 lg:-left-12 lg:w-56" data-id="element-96" data-mp="1ayt6mzo5djaw">
            <img src={images.pack} alt="Mockup del Megapack: los 6 tomos digitales y las plantillas de planificación" className="w-full rounded-xl" width={512} height={512} data-id="element-97" data-mp="111es55lsb4l8" />
            <p className="mt-2 text-center text-[11px] font-semibold uppercase tracking-wide text-ink-muted" data-id="element-98" data-mp="3hrlm2muo2fb3">
              6 tomos + 5 bonos
            </p>
          </div>
        </div>
      </div>
    </section>;
}